/**
 * Hooks para entregables previos por club.
 */

import { useEffect, useState } from "react";
import {
  subscribeToSubmissionsByClub,
  subscribeToSubmissionsByEvent,
} from "@/lib/services/activitySubmissions";
import type { ClubActivitySubmission } from "@/types";

export function useEventSubmissions(eventId: string | undefined) {
  const [data, setData] = useState<ClubActivitySubmission[] | undefined>(
    undefined,
  );
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!eventId) {
      setData([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    const unsub = subscribeToSubmissionsByEvent(
      eventId,
      (items) => {
        setData(items);
        setIsLoading(false);
      },
      (err) => {
        setError(err);
        setIsLoading(false);
      },
    );
    return unsub;
  }, [eventId]);

  return { data, isLoading, error };
}

export function useClubSubmissions(
  eventId: string | undefined,
  clubId: string | undefined,
) {
  const [data, setData] = useState<ClubActivitySubmission[] | undefined>(
    undefined,
  );
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!eventId || !clubId) {
      setData([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setError(null);
    const unsub = subscribeToSubmissionsByClub(
      eventId,
      clubId,
      (items) => {
        setData(items);
        setIsLoading(false);
      },
      (err) => {
        setError(err);
        setIsLoading(false);
      },
    );
    return unsub;
  }, [eventId, clubId]);

  return { data, isLoading, error };
}
